import type { Template } from "@/types";

export const PO_07_H0_V7: Template[] = [
    {
        id: "po-07-h0v7-01",
        name: "PO 01 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 279, width: 179, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 187, y: 279, width: 179, height: 270, rotation: 0, imageRotation: 0 },
            { id: "3", x: 374, y: 279, width: 179, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 561, y: 279, width: 179, height: 270, rotation: 0, imageRotation: 0 },
            { id: "5", x: 748, y: 279, width: 178, height: 270, rotation: 0, imageRotation: 0 },
            { id: "6", x: 934, y: 279, width: 178, height: 270, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1120, y: 279, width: 178, height: 270, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-02",
        name: "PO 02 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_02.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 61, y: 167, width: 171, height: 242, rotation: 0, imageRotation: 0 },
            { id: "2", x: 240, y: 167, width: 170, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 418, y: 167, width: 170, height: 242, rotation: 0, imageRotation: 0 },
            { id: "4", x: 61, y: 417, width: 171, height: 242, rotation: 0, imageRotation: 0 },
            { id: "5", x: 240, y: 417, width: 170, height: 242, rotation: 0, imageRotation: 0 },
            { id: "6", x: 418, y: 417, width: 170, height: 242, rotation: 0, imageRotation: 0 },
            { id: "7", x: 799, y: 167, width: 348, height: 492, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-03",
        name: "PO 03 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_03.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 167, y: 83, width: 154, height: 215, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 83, width: 154, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 167, y: 306, width: 154, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 306, width: 154, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 167, y: 528, width: 154, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 329, y: 528, width: 154, height: 214, rotation: 0, imageRotation: 0 },
            { id: "7", x: 750, y: 83, width: 449, height: 659, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-04",
        name: "PO 04 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 33, y: 0, width: 583, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 690, y: 139, width: 184, height: 270, rotation: 0, imageRotation: 0 },
            { id: "3", x: 882, y: 139, width: 184, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1074, y: 139, width: 184, height: 270, rotation: 0, imageRotation: 0 },
            { id: "5", x: 690, y: 417, width: 184, height: 270, rotation: 0, imageRotation: 0 },
            { id: "6", x: 882, y: 417, width: 184, height: 270, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1074, y: 417, width: 184, height: 270, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-05",
        name: "PO 05 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_05.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 52, y: 220, width: 270, height: 389, rotation: 0, imageRotation: 0 },
            { id: "2", x: 330, y: 220, width: 131, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 330, y: 419, width: 131, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 469, y: 220, width: 130, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 469, y: 419, width: 130, height: 190, rotation: 0, imageRotation: 0 },
            { id: "6", x: 700, y: 220, width: 271, height: 389, rotation: 0, imageRotation: 0 },
            { id: "7", x: 978, y: 220, width: 270, height: 389, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-06",
        name: "PO 06 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 61, y: 157, width: 416, height: 513, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 485, y: 157, width: 117, height: 166, rotation: 0, imageRotation: 0 },
            { id: "3", x: 485, y: 331, width: 117, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 485, y: 505, width: 117, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 698, y: 157, width: 358, height: 513, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1064, y: 157, width: 175, height: 253, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1064, y: 418, width: 175, height: 252, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-07",
        name: "PO 07 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_07.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 64, y: 80, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 418, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 301, y: 80, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "4", x: 301, y: 418, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "5", x: 538, y: 80, width: 461, height: 668, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1007, y: 80, width: 228, height: 330, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1007, y: 418, width: 228, height: 330, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-08",
        name: "PO 08 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_08.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 64, y: 80, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 301, y: 80, width: 228, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 537, y: 80, width: 228, height: 330, rotation: 0, imageRotation: 0 },
            { id: "4", x: 64, y: 418, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "5", x: 301, y: 418, width: 228, height: 330, rotation: 0, imageRotation: 0 },
            { id: "6", x: 537, y: 418, width: 228, height: 330, rotation: 0, imageRotation: 0 },
            { id: "7", x: 773, y: 80, width: 461, height: 668, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-09",
        name: "PO 09 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 64, y: 80, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 418, width: 229, height: 330, rotation: 0, imageRotation: 0 },
            { id: "3", x: 301, y: 80, width: 463, height: 668, rotation: 0, imageRotation: 0 },
            { id: "4", x: 772, y: 80, width: 228, height: 330, rotation: 0, imageRotation: 0 },
            { id: "5", x: 772, y: 418, width: 228, height: 330, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1008, y: 80, width: 227, height: 330, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1008, y: 418, width: 227, height: 330, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-10",
        name: "PO 10 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 195, width: 146, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 417, width: 146, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 154, y: 195, width: 146, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 154, y: 417, width: 146, height: 213, rotation: 0, imageRotation: 0 },
            { id: "5", x: 308, y: 195, width: 326, height: 435, rotation: 0, imageRotation: 0 },
            { id: "6", x: 642, y: 195, width: 325, height: 435, rotation: 0, imageRotation: 0 },
            { id: "7", x: 975, y: 195, width: 325, height: 435, rotation: 0, imageRotation: 0 }
        ],
    }
];